import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dw-image-zoom-modal',
  templateUrl: './dw-image-zoom-modal.component.html',
  styleUrls: ['./dw-image-zoom-modal.component.scss']
})
export class DwImageZoomModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
